import React from 'react';
import Hide from '@uber/base-icons/hide';
import Show from '@uber/base-icons/show';
import { styled } from 'baseui';
import { ListItem } from 'baseui/list';
import { DeleteButton } from '../../side-panel/annotation-header';
import { ActionButton } from '../../side-panel/annotation-header/action-button';
import { ICON_SIZE } from '../../side-panel/annotation-header/constants';
import type { HeaderInfoT } from '../../side-panel/annotations/types';
import { useVisibilityMode } from './hooks/use-visibility-mode';
import { HeaderContent } from './header-content';
type PropsT = {
  headerInfo: HeaderInfoT;
  label: string;
  icon: React.ReactNode;
  onDeleteAllAnnotations: () => void;
};
const ActionButtonsRow = styled('div', {
  display: 'flex',
  alignItems: 'center'
});
const listItemOverrides = {
  Root: {
    style: () => ({
      width: '100%',
      overflow: 'hidden',
      backgroundColor: 'transparent'
    })
  },
  Content: {
    style: {
      margin: '0',
      minHeight: 'auto',
      padding: '0'
    }
  }
};
export function AnnotationDetailsHeader({
  headerInfo,
  label,
  icon,
  onDeleteAllAnnotations
}: PropsT) {
  const {
    activeLabelOnly,
    toggleLabelOnly
  } = useVisibilityMode();
  const isLabelOnlyActive = activeLabelOnly === label;
  return <ListItem hasDivider={false} overrides={listItemOverrides} aria-label={`${label} annotation header`}>
      <HeaderContent label={label} headerInfo={headerInfo} icon={icon} />
      <ActionButtonsRow>
        <ActionButton icon={isLabelOnlyActive ? <Hide size={ICON_SIZE} /> : <Show size={ICON_SIZE} />} name={isLabelOnlyActive ? 'Show all annotations' : 'Show only this label'} onClick={e => {
        e.stopPropagation();
        toggleLabelOnly(label);
      }} />
        <DeleteButton onClick={e => {
        e.stopPropagation();
        onDeleteAllAnnotations();
      }} size={14} />
      </ActionButtonsRow>
    </ListItem>;
}